import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const MainSurveyBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M2 5.5V12C2 12.8284 2.67157 13.5 3.5 13.5H12.5C13.3284 13.5 14 12.8284 14 12V5.5M2 5.5V4C2 3.17157 2.67157 2.5 3.5 2.5H12.5C13.3284 2.5 14 3.17157 14 4V5.5M2 5.5H14M3.5 4H3.505V4.005H3.5V4ZM5 4H5.005V4.005H5V4ZM6.5 4H6.505V4.005H6.5V4Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconContainer>
);
